import { Users } from "../user/types";
import { type Affiliate } from "./types";

export const isAvailable = (
  profile: Users.Api.DashboardAffiliate,
  availability: Affiliate.Availability | undefined
): boolean => {
  if (!availability) return true;

  if (availability.rankIds) {
    return profile.rankId ? availability.rankIds.includes(profile.rankId) : false;
  }

  return true;
};
